export enum BookingState {
  Pending = 1,
  Confirmed = 2,
  CanceledByUser = 3,
  CanceledByProvider = 4,
  Canceled = 5
};